import type { DashboardDateRange } from "../dashboard";
import type { DashboardAreaKey } from "../dashboard-areas";
import { summarizeAudit, summarizeUsers, type ActivityInput, type UsersInput } from "./activity";
import type { AreaSummary } from "./build";
import { summarizeContacts, type ContactsInput } from "./contacts";
import { summarizeInventory, type InventoryInput } from "./inventory";
import { summarizeOrders, type OrdersInput } from "./orders";
import { summarizeTransactions, type TransactionsInput } from "./transactions";

export type DashboardAreaInputs = {
  inventory: InventoryInput;
  transactions: TransactionsInput;
  orders: OrdersInput;
  contacts: ContactsInput;
  audit: ActivityInput;
  users: UsersInput;
};

export type { DashboardAreaKey };

export const DASHBOARD_SUMMARIZERS: { [K in DashboardAreaKey]: (input: DashboardAreaInputs[K], range: DashboardDateRange) => AreaSummary } = {
  inventory: summarizeInventory,
  transactions: summarizeTransactions,
  orders: summarizeOrders,
  contacts: summarizeContacts,
  audit: summarizeAudit,
  users: summarizeUsers,
};

export type { AreaSummary };
